module.exports = __webpack_public_path__ + "media/theme/step--2-efb5ba08.png";